// Разбор правила округления "step:threshold" (+ legacy-токены) и человекочитаемый лейбл.

// i18next t (свободный тип, чтобы принять и TFunction, и локальный t)
type Tr = (key: string, def?: any) => any;

const LEGACY: Record<string, [number, number]> = {
  up: [1, 0], full_up: [1, 0], up_half: [0.5, 0], half_up: [0.5, 0],
  nearest_half: [0.5, 0.5], tenth: [0.1, 0.5],
};

export function parseRoundRule(v?: string): { step: number; thr: number; none: boolean } {
  if (!v || v === 'none') return { step: 1, thr: 0.5, none: true };
  if (LEGACY[v]) return { step: LEGACY[v][0], thr: LEGACY[v][1], none: false };
  const [s, th] = v.split(':');
  const step = Number(s) || 1;
  const thr = th !== undefined && !isNaN(Number(th)) ? Number(th) : 0.5;
  return { step, thr, none: false };
}

// Пример: "up to whole day", "to nearest 0.5 hour", "whole day · up from 0.3", "down to whole day"
export function roundRuleLabel(step: number, thr: number, unitWord: string, t: Tr): string {
  const stepPhrase = step === 1 ? `${t('HrStepWholeWord', 'whole')} ${unitWord}` : `${step} ${unitWord}`;
  if (thr <= 0) return `${t('HrRuleWordUp', 'up to')} ${stepPhrase}`;
  if (thr >= 1) return `${t('HrRuleWordDown', 'down to')} ${stepPhrase}`;
  if (Math.abs(thr - 0.5) < 1e-9) return `${t('HrRuleWordNearest', 'to nearest')} ${stepPhrase}`;
  return `${stepPhrase} · ${t('HrRuleWordUpFrom', 'up from')} ${thr}`;
}
